import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* updateLookbookOrderFulfillmentPackage({ payload: { id, orderId, fulfillmentId, packageId, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.lookbooks.orders.fulfillments.packages.update,
      pathParams: { id, orderId, fulfillmentId, packageId },
      data: values
    });

    onSuccess && onSuccess();
    yield put(actions.updateLookbookOrderFulfillmentPackageDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.updateLookbookOrderFulfillmentPackageFailed,
      handledErrors,
      endpoint: api.lookbooks.orders.fulfillments.packages.update.url
    });
  }
}

export const updateLookbookOrderFulfillmentPackageSaga = takeEvery(types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_REQUEST, updateLookbookOrderFulfillmentPackage);
